export const config = {
  dataset: "production",
  projectId: "mkcgxu4r",
  apiVersion: "2022-01-11",
  useCdn: true,
};
